export default "__VITE_ASSET__DYfQR3V5__"